import rest from "@/restUtils";
import utils from "@/utils";

export default {
    namespace: true,
    state: {},
    actions: {
        async getClientsBase(context, {nameOrEmail, tariff, page, size}) {
            try {
                let users = await rest.doGet(`/user/client-base?page=${page || 0}${!!size ? '&size=' + size : ''}${!!nameOrEmail ? '&nameOrEmail=' + nameOrEmail : ''}${!!tariff && tariff.length > 0 ? '&tariff=' + tariff.join(',') : ''}`);

                if (!!users && users.length > 0) {
                    users.forEach(user => {
                        let subEndDate = utils.convertDateToUTC(new Date(user.subEndDate));
                        Object.assign(user, {subEndDate});
                    });
                }

                return users;
            } catch (error) {
                alert(error.response.data.message);
            }
        }
    },
    mutations: {},
    getters: {}
}